import { useAppSelector } from "../../../store/types";
import { getTranslatedTextSelector } from "../../../selectors/settingsSelector";
import type { TranslationEntry } from "../../../components/SbuxTranslate";

const useTextTranslate = (text: string) => {
  const translatedText = useAppSelector(getTranslatedTextSelector);

  const translate = (text: string): string => {
    const typedTranslatedText = translatedText as
      | TranslationEntry[]
      | undefined;
    if (
      !typedTranslatedText ||
      !Array.isArray(typedTranslatedText) ||
      typedTranslatedText.length === 0
    ) {
      return text;
    }
    const result = typedTranslatedText.find((f) => f.sourceText === text);
    return result?.translatedText ?? text;
  };

  return translate(text);
};

export default useTextTranslate;
